<template>
    <CSidebar fixed :minimize="minimize" :show="show" @update:show="(value) => $store.commit('setSidebarShow', [value])">
        <CSidebarBrand class="py-1" to="/">
            <img class="m-3" src="@/assets/images/wappen_64.png" height="40" />
            <span class="c-sidebar-brand-full text-uppercase text-50 ml-1 mr-3">
                <h6 class="mt-2 mb-0 pb-0">Heimat- und Verkehrsverein</h6>
                <h5 class="mt-1 mb-2 pt-0">Sabbenhausen</h5>
            </span>
        </CSidebarBrand>

        <hr class="c-sidebar-divider" />
        <CSidebarNav>
            <CSidebarNavItem icon="cilHome" name="Startseite" to="/" />
            <hr class="c-sidebar-divider" />
            <CSidebarNavTitle>Das Dorf</CSidebarNavTitle>
            <CSidebarNavItem icon="cilNewspaper" name="Aktuelles" to="/news" />
            <CSidebarNavItem icon="cilMap" name="Lage" to="/location" />
            <CSidebarNavItem icon="cilShieldAlt" name="Wappen" to="/emblem" />
            <CSidebarNavItem icon="cilHistory" name="Geschichte" to="/history" />
            <hr class="c-sidebar-divider" />
            <CSidebarNavTitle>Der Verein</CSidebarNavTitle>
            <CSidebarNavItem icon="cilPenAlt" name="Mitglied werden..." to="/member" />
            <CSidebarNavItem icon="cilPeople" name="Ansprechpartner" to="/persons" />
            <CSidebarNavItem icon="cilTask" name="Aufgaben" to="/mission" />
            <hr class="c-sidebar-divider" />
            <CSidebarNavTitle>Kontakt</CSidebarNavTitle>
            <CSidebarNavItem icon="cilEnvelopeClosed" name="Kontakt" to="/contact" />
            <CSidebarNavItem icon="cilBank" name="Impressum" to="/imprint" />
            <CSidebarNavItem icon="cilLockLocked" name="Datenschutz" to="/privacy" />
        </CSidebarNav>
        <hr class="c-sidebar-divider" />

        <CSidebarMinimizer class="d-md-down-none" @click.native="$store.commit('setSidebarMinimize', [!minimize])" />
    </CSidebar>
</template>


<script>
    export default {
        name: 'HvvSidebar',
        computed: {
            show () {
                return this.$store.getters.getViewSidebarShow
            },
            minimize () {
                return this.$store.getters.getViewSidebarMinimize
            }
        }
    }
</script>